export const CLOUD_BLUE_RESOURCE_QUANTITY_UNLIMITED = -1

export function normalizeMaxQuantity(value: number): number {
  return value === CLOUD_BLUE_RESOURCE_QUANTITY_UNLIMITED ? Infinity : value
}
